<template>
  <footer>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="8">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
              <div>
                <v-btn class="footer__logo" to="/" text color="#fff">
                  <img alt src="img/icons/logo_v3_white.svg" />
                </v-btn>
                <!-- <v-btn text color="#fff">Mapa</v-btn> -->
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <div class="ctn__footer__action">
                <v-btn text to="/">INICIO</v-btn>
                <v-btn text to="/price">Precios</v-btn>
                <v-btn text to="/help">ayuda</v-btn>
                <v-btn text href="https://medium.com/lubumas">Blog</v-btn>
              </div>
              <div class="ctn__footer__txt">
                <p>
                  El uso de este sitio está sujeto a las condiciones de uso
                  expresas. Al utilizar este sitio, tú indicas que aceptas
                  cumplir con estos Términos universales de servicio.
                </p>
              </div>
              <div class="ctn__footer__sub">
                <v-btn
                  href="https://www.facebook.com/lubumas"
                  target="_blank"
                  text
                  color="#fff"
                  >Facebook</v-btn
                >
                <v-btn
                  href="https://twitter.com/lubu_mas"
                  target="_blank"
                  text
                  color="#fff"
                  >TWITTER</v-btn
                >
                <v-btn
                  href="https://www.instagram.com/lubumas/"
                  target="_blank"
                  text
                  color="#fff"
                  >INSTAGRAM</v-btn
                >
                <!-- <v-btn text to="/" color="#fff">Terminos de servicios</v-btn> -->
                <!-- <v-btn text to="/" color="#fff">Politicas de privacidad</v-btn> -->
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <div class="section__date">
            <div class="ctn__date">
              <p>
                <a target="_blank" href="mailto:info@lubu.com.co"
                  >info@lubu.com.co</a
                >
              </p>
              <p class="num">+57 300 798 3173</p>
              <p>Colombia</p>
              <p>Neiva - Huila</p>
              <p class="by">© 2020 Lbumas</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base.scss";
footer {
  color: #fff;
  background: $bg-footer;
  //min-height: 300px;

  a {
    color: $footer-link;
    &.footer__logo {
      img {
        width: 120px;
      }
    }
  }
  .section__date {
    text-align: right;
    display: flex;
    height: 100%;
    align-items: flex-end;
    justify-content: flex-start;
    padding-top: 10px;
    padding-left: 15px;
    @media #{$large-up} {
      padding-left: 0;
      padding-top: 0px;
      justify-content: flex-end;
    }

    .ctn__date {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      @media #{$large-up} {
        display: block;
      }
      a {
        font-family: "Roboto Condensed", sans-serif;
      }
      p {
        color: #848484;
        font-family: "Roboto Condensed", sans-serif;
        line-height: 1.4;
        font-size: 1rem;
        margin-bottom: 5px;
        margin-right: 5px;
        @media #{$tablet-up} {
          padding-right: 0px;
          margin-bottom: 0;
        }
        &.num {
          font-size: 1rem;
        }
        &.by {
          font-family: "Roboto Condensed", sans-serif;
          font-size: 1rem;
          margin-bottom: 0;
          @media #{$large-up} {
            padding-bottom: 10px;
          }
        }
      }
    }
  }
  .ctn__footer__txt {
    p {
      color: #848484;
      font-size: 0.85rem;
    }
  }
  .ctn__footer__sub {
    a {
      font-size: 0.75rem;
    }
  }
  .ctn__footer__action {
    padding: 20px 0;
    a {
      height: 27px !important;
      color: $footer-link;
      &:hover {
        color: $color-primary-light;
      }
      &.footer__logo {
        img.logo {
          width: 120px;
        }
      }
    }
  }

  ul.menu__footer {
    margin-top: 20px;
    a {
      height: 27px !important;
      color: $footer-link;
      &:hover {
        color: $color-primary-light;
      }
      &.footer__logo {
        img.logo {
          width: 120px;
        }
      }
    }
  }
}
</style>
